import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Chip, CircularProgress } from '@mui/material';
import api from '../../api';

const PendingActionsSection = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const empId = localStorage.getItem('emp_id');

  useEffect(() => {
    fetchPendingActions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchPendingActions = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/pending-actions/list?emp_id=${empId}`);
      setData(res.data);
    } catch (err) {
      console.error("Failed to fetch pending actions", err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    const s = status.toUpperCase();
    if (s.includes('PENDING')) return 'warning';
    return 'default';
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // EMPTY STATE
  if (data.length === 0) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
        <img src="/no_pending.png" alt="No Pending Actions" style={{ width: '25%', opacity: 0.8 }} />
        <Typography variant="h6" color="textSecondary" sx={{ mt: 3, fontWeight: 'bold' }}>
          You're all caught up!
        </Typography>
        <Typography variant="body2" color="textSecondary">
          No pending approvals require your attention at this time.
        </Typography>
      </Box>
    );
  }

  // DATA TABLE STATE
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h6" fontWeight="bold" color="#10394f" mb={3}>
        Pending Actions
      </Typography>
      
      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: 2 }}>
        <Table size="small">
          <TableHead sx={{ bgcolor: '#f8fafc' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', color: '#555' }}>Emp ID</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#555' }}>Employee Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#555' }}>Date</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#555' }}>Subject</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#555' }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index} hover>
                <TableCell>{row.emp_id}</TableCell>
                <TableCell sx={{ fontWeight: 500 }}>{row.employee_name}</TableCell>
                <TableCell>{row.action_date ? new Date(row.action_date).toLocaleDateString() : '--'}</TableCell>
                <TableCell>{row.subject}</TableCell>
                <TableCell>
                  <Chip 
                    label={row.status} 
                    size="small" 
                    color={getStatusColor(row.status)} 
                    variant="outlined" 
                    sx={{ fontWeight: 'bold' }} 
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PendingActionsSection;